import React from 'react'
import { Text, Tooltip } from 'pcln-design-system'

const EmailErrorTooltip = (props) => (
  <Tooltip bottom right color='red' zIndex={1}>
    <Text color='white'>
      Please enter a valid email.
    </Text>
  </Tooltip>
)

EmailErrorTooltip.displayName = 'EmailErrorTooltip'

export default EmailErrorTooltip
